import React from "react"
import { graphql } from "gatsby"
import BlockContent from "@sanity/block-content-to-react"
import { Text } from "@gorilla-technologies/customer-ui"

export const TextBlock = ({ _rawContent }: HeroBlockProps) => (
  <Text>
    <BlockContent blocks={_rawContent} />
  </Text>
)

export type HeroBlockProps = {
  _rawContent: string
}

export const TextBlockFragment = graphql`
  fragment TextFields on SanityWysiwyg {
    _rawContent
  }
`
